import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { BsFillPersonFill } from "react-icons/bs";
import { FaUserNurse } from "react-icons/fa";
import CommanSpinner from "../components/CommanSpinner";

const CreateOrderDialog = ({
  createOrder,
  createAttachOrderPopup,
  closePopup,
  patientTypeDropdown,
  providerTypeDropdown,
  selectedPatientValue,
  selectedProviderValue,
  currentPage,
  moveFaxToTrash,
  setMoveFaxToTrash,
  moveChildFaxToTrash,
  setMoveChildFaxToTrash,
  isLastChild,
  createOrderAndAttach,
  loader,
}) => {
  const getTitleText = () => {
    const patientText =
      patientTypeDropdown === "New"
        ? "you will create a new patient, new order"
        : "you will create a new order for this patient";
    const providerText =
      providerTypeDropdown === "New" ? "and a new provider" : "";
    const attachText =
      patientTypeDropdown === "New"
        ? "and attach the document to that patient and order."
        : "and attach this document to the new order.";

    return `If you continue ${patientText} ${providerText} ${attachText}`;
  };

  const getDialogTitle = () => {
    return patientTypeDropdown === "New"
      ? "Create New Patient and Order"
      : "Create New Order";
  };

  return (
    <>
      <Button variant="contained" onClick={(e) => createOrder(e)}>
        CREATE & ATTACH TO ORDER
      </Button>

      <Dialog
        open={createAttachOrderPopup}
        onClose={closePopup}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={closePopup}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle sx={{ textAlign: "left", pt: 4 }}>
            {getDialogTitle()}
          </DialogTitle>

          <DialogContent>
            {getTitleText()}
            <Box sx={{ mt: 2 }}>
              {patientTypeDropdown === "Existing" && (
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <BsFillPersonFill />
                  Patient Name: {selectedPatientValue?.name || ""}
                </Typography>
              )}

              {selectedProviderValue?.name !== "Provider not selected" && (
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <FaUserNurse />
                  Provider Name: {selectedProviderValue?.name || ""}
                </Typography>
              )}
            </Box>

            <Box sx={{ mt: 3 }}>
              {currentPage === "parent" ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveFaxToTrash}
                      onChange={() => setMoveFaxToTrash(!moveFaxToTrash)}
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label="Remove fax from inbox"
                />
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveChildFaxToTrash}
                      onChange={() =>
                        setMoveChildFaxToTrash(!moveChildFaxToTrash)
                      }
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label={
                    isLastChild
                      ? "Move parent fax to trash as well"
                      : "Move child fax to trash"
                  }
                />
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 3, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={closePopup}
              sx={{
                color: "#00AB4E",
                borderColor: "#00AB4E",
                "&:hover": {
                  borderColor: "#008C40",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => createOrderAndAttach("create")}
              disabled={loader}
              sx={{
                backgroundColor: "#00AB4E",
                "&:hover": {
                  backgroundColor: "#008C40",
                },
              }}
            >
              CREATE & Attach
            </Button>
          </DialogActions>
        </Box>

        {/* {loader === "create&attachOrderLoader" && (
          <CommanSpinner spinner={loader} text="" />
        )} */}
      </Dialog>
    </>
  );
};

export default CreateOrderDialog;
